<script>
export default {
  name: 'HealthCheck',

  data () {
    return {
      healthData: {
        status: 'ok',
        version: process.env.VUE_APP_VERSION || '0.1.0',
        buildDate: process.env.VUE_APP_BUILD_DATE || 'N/A',
        commit: process.env.VUE_APP_COMMIT_SHA || 'N/A',
        branch: process.env.VUE_APP_COMMIT_REF_NAME || 'N/A',
        pipeline: process.env.VUE_APP_PIPELINE_ID || 'N/A',
        environment: process.env.NODE_ENV || 'development',
        timestamp: new Date().toISOString(),
      },
    }
  },

  computed: {
    formattedJson () {
      return JSON.stringify(this.healthData, null, 2)
    },

    formattedDate () {
      if (this.healthData.buildDate === 'N/A') return 'N/A'
      try {
        const date = new Date(this.healthData.buildDate)
        return date.toLocaleString('pt-BR', {
          timeZone: 'America/Sao_Paulo',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      } catch {
        return this.healthData.buildDate
      }
    },
  },
}
</script>

<template>
  <div :class="$classes['healthcheck-container']">

    <div :class="$classes['content']">
      <div :class="$classes['info-card']">
        <div :class="$classes['header']">
          <span :class="$classes['title']">Informações de Versão</span>
          <p :class="$classes['subtitle']">Informações de build e versão da aplicação</p>
        </div>
        <div :class="$classes['info-row']">
          <span :class="$classes['label']">Status:</span>
          <span :class="[$classes['value'], $classes['status-ok']]">{{ healthData.status.toUpperCase() }}</span>
        </div>

        <div :class="$classes['info-row']">
          <span :class="$classes['label']">Versão:</span>
          <span :class="$classes['value']">{{ healthData.version }}</span>
        </div>

        <div :class="$classes['info-row']">
          <span :class="$classes['label']">Commit:</span>
          <span :class="$classes['value']">{{ healthData.commit }}</span>
        </div>

        <div :class="$classes['info-row']">
          <span :class="$classes['label']">Branch:</span>
          <span :class="$classes['value']">{{ healthData.branch }}</span>
        </div>

        <div :class="$classes['info-row']">
          <span :class="$classes['label']">Pipeline ID:</span>
          <span :class="$classes['value']">{{ healthData.pipeline }}</span>
        </div>

        <div :class="$classes['info-row']">
          <span :class="$classes['label']">Data do Build:</span>
          <span :class="$classes['value']">{{ formattedDate }}</span>
        </div>

        <div :class="$classes['info-row']">
          <span :class="$classes['label']">Ambiente:</span>
          <span :class="$classes['value']">{{ healthData.environment }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<style module>
.healthcheck-container {
  height: 100%;
  background: url('~@/assets/images/home.png') no-repeat center;
  background-size: cover;
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header {
  margin-bottom: 2rem;
}

.title {
  font-size: 24px;
  font-weight: 600;
  color: rgba(41, 41, 41, 1);
  margin: 0 0 0.5rem 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.subtitle {
  font-size: 1rem;
  color: rgba(41, 41, 41, 0.7);
  margin: 0;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.info-card {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.info-row:last-child {
  border-bottom: none;
}

.label {
  font-weight: 500;
  color: rgba(41, 41, 41, 0.8);
  text-transform: uppercase;
  font-size: 0.875rem;
  letter-spacing: 0.05em;
}

.value {
  color: rgba(41, 41, 41, 1);
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  word-break: break-all;
  text-align: right;
  margin-left: 1rem;
}

.status-ok {
  color: #28a745;
  font-weight: 600;
}

.json-section {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.json-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: rgba(41, 41, 41, 1);
  margin: 0 0 1rem 0;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.json-code {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 1rem;
  overflow-x: auto;
  margin: 0;
  font-family: 'Courier New', monospace;
  font-size: 0.875rem;
  line-height: 1.5;
  color: rgba(41, 41, 41, 1);
}

.json-code code {
  display: block;
  white-space: pre;
}

@media (max-width: 767px) {
  .healthcheck-container {
    padding: 1rem;
  }

  .title {
    text-transform: uppercase;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.01em;
    color: #292929
  }

  .info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .value {
    text-align: left;
    margin-left: 0;
  }
}
</style>
